const buildVersion = "1.0.0";

export default buildVersion;
